import script from "./ow-view-rep-sales-monthly-yearly-summary.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-view-rep-sales-monthly-yearly-summary.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__